import { Button, MainContainer } from '@p2p/components';

import styles from './SuccessTransfer.module.scss';

export type SuccessTransferProps = {
  url: string;
};

export const SuccessTransfer = (props: SuccessTransferProps) => {
  const { url } = props;
  const handleNavigate = () => {
    window.location.href = url;
  };
  return (
    <MainContainer>
      <div className={styles.wrapper}>
        <h1>Спасибо! Оплата прошла успешно</h1>
        <Button variant="v1" onClick={handleNavigate} className={styles.btn__back} fullWidth>
          Вернуться на сайт партнера
        </Button>
      </div>
    </MainContainer>
  );
};
